export interface IErrorModel {
    statusCode: number;
    message: string;
}

export const isErrorModel = (obj: any) => {
    return obj.hasOwnProperty('message');
};
